/* @ngInject */

export default (
  $rootScope,
  $scope,
  $filter,
  webpage,
  eventService,
  labelService,
  labelsService,
  actionService,
  LABEL
) => {
  $scope.Model = {
    availableLabels: [],
    filteredLabels: [],
    availableTypes: LABEL.TYPES,
    filters: {
      currentType: ''
    },
    labelsList: null,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  if ($rootScope.CurrentAccount.isAdministrator) {
    loadLabels();
  }
  function loadLabels() {
    webpage.pageTitle('Loading, please wait');
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: !$scope.Model.isArchive
      })
      .then(function (data) {
        // Set Model values
        $scope.Model.availableLabels = data;
        $scope.Model.filteredLabels = data;
      })
      .then(function () {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Status Label : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('labelDelete', function () {
    labelsService.clearCache();
    actionService.deleteDocuments(
      $scope.Model.labelsList.getSelected(),
      labelService.deleteLabel,
      $scope.Model.labelsList.removeData,
      'label(s)'
    );
  });
  $scope.$on('labelDuplicate', function () {
    labelsService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.labelsList.getSelected(),
      labelService.readLabel,
      labelService.createLabel,
      $scope.Model.labelsList.setDataAppend,
      'name',
      ' copy',
      'label(s)'
    );
  });
  $scope.$on('labelActivate', function () {
    labelsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.labelsList.getSelected(),
      labelService.updateLabel,
      $scope.Model.labelsList.removeData,
      'label(s)',
      true
    );
  });
  $scope.$on('labelArchive', function () {
    labelsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.labelsList.getSelected(),
      labelService.updateLabel,
      $scope.Model.labelsList.removeData,
      'label(s)',
      false
    );
  });
  $scope.$on('labelAdd', function (e, $event) {
    labelsService.clearCache();
    eventService.labelEdit({ event: $event, label: null, list: $scope.Model.labelsList });
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.labelEdit = function ($event, label) {
    eventService.labelEdit({ event: $event, label: label, list: $scope.Model.labelsList });
  };
  $scope.labelEdited = function (label) {
    labelsService.clearCache();
    if (label.isNew === true) {
      delete label.isNew;
      if (label.isActive !== $scope.Model.isArchive) {
        $scope.Model.labelsList.setDataAppend(label);
      }
    } else {
      $scope.Model.labelsList.setDataReplace(label);
    }
  };
  $scope.listChange = function (list, data, isSelected) {
    $scope.$parent.Model.childStateHasSelection = isSelected
      ? isSelected
      : list.isSelectedAny();
  };
  $scope.listReady = function (list) {
    $scope.Model.labelsList = list;
    $scope.Model.watcher = $scope.$parent.$watch('Model.childStateIsArchive', function (
      newValue,
      oldValue
    ) {
      if (newValue !== oldValue) {
        $scope.Model.isArchive = newValue;
        $scope.Model.isReady = false;
        $scope.Model.watcher();
        loadLabels();
      }
    });
  };

  $scope.labelsFilter = function ($event, type) {
    $event.stopPropagation();
    if (type !== '') {
      $scope.Model.filters.currentType =
        type === null ? $scope.Model.filters.currentType : type;
      $scope.Model.filters.currentTypeDisplay =
        'Type' +
        ($scope.Model.filters.currentType !== '' && $scope.Model.filters.currentType !== null
          ? ': ' + $scope.Model.filters.currentType.capitalizeFirstLetter()
          : '');
      $scope.Model.availableLabels = $filter('stLabelsFilter')(
        $scope.Model.filteredLabels,
        $scope.Model.filters.currentType
      );
      $scope.Model.labelsList.setData($scope.Model.availableLabels);
    } else {
      $scope.Model.filters.currentType = '';
      $scope.Model.filters.currentTypeDisplay = 'Type';
      $scope.Model.availableLabels = $filter('stLabelsFilter')(
        $scope.Model.filteredLabels,
        $scope.Model.filters.currentType
      );
      $scope.Model.labelsList.setData($scope.Model.availableLabels);
    }
  };
};
